export const getItemFromLocalStorage = (key: string) => localStorage.getItem(key);
export const setItemToLocalStorage = (key: string, value: string) => localStorage.setItem(key, value);
export const removeItemFromLocalStorage = (key: string) => localStorage.removeItem(key);
